if (process.env.NODE_ENV !== 'production' || process.env.CI) {
  // this needs to be required synchronously to get test utils loaded before the app's code
  // eslint-disable-next-line global-require
  require('./testUtils')
}
